import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CircleCloseFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 2.56c-5.21 0-9.44 4.23-9.44 9.44 0 5.21 4.23 9.44 9.44 9.44 5.21 0 9.44-4.23 9.44-9.44 0-5.21-4.23-9.44-9.44-9.44Zm3.31 11.64c.31.31.31.8 0 1.11a.78.78 0 0 1-.55.23c-.2 0-.4-.08-.55-.23L12 13.1l-2.21 2.21a.78.78 0 0 1-.55.23c-.2 0-.4-.08-.55-.23a.779.779 0 0 1 0-1.11l2.21-2.21-2.21-2.21a.779.779 0 0 1 0-1.11c.31-.3.8-.3 1.11 0l2.21 2.21 2.21-2.21c.31-.3.8-.3 1.11 0 .31.31.31.8 0 1.11l-2.21 2.21 2.21 2.21h-.02Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CircleCloseFilled
